import { get } from "svelte/store";
import { ReadableStore } from "../Model/ReadableStore";
export function debounce(ms) {
    let timeout;
    return (fn, ...args) => {
        window.clearTimeout(timeout);
        timeout = window.setTimeout(fn, ms, ...args);
    };
}
/**
 *	Convierte una cadena en una expresión regular apropiada para hacer búsquedas
 */
export function likeRegexp(string, abs = false) {
    //Añadimos el rango de caracteres combinados a las expresiones
    //regulares de búsqueda de vocales ([\u0300-\u036F])
    //Eliminamos estos caracteres ya que es el estilo de acentos que usa OSX
    //https://en.wikipedia.org/wiki/Combining_character
    string = string.replace(/[aáàä][\u0300-\u036F]?/ig, '[aáàä]');
    string = string.replace(/[eéèë][\u0300-\u036F]?/ig, '[eéèë]');
    string = string.replace(/[iíìï][\u0300-\u036F]?/ig, '[iíìï]');
    string = string.replace(/[oóòö][\u0300-\u036F]?/ig, '[oóòö]');
    string = string.replace(/[uúùü][\u0300-\u036F]?/ig, '[uúùü]');
    if (abs) {
        string = '^' + string + '$';
    }
    return new RegExp(string, 'i');
}
export function readableFrom(readables) {
    const lastValues = readables.map(readable => get(readable));
    return new ReadableStore(lastValues, set => {
        const unsubscribers = readables.map((readable, index) => {
            return readable.subscribe(value => {
                lastValues[index] = value;
                set(lastValues);
            });
        });
        return () => unsubscribers.forEach(unsubscribe => unsubscribe());
    });
}
export function answerInvalidateForm(question, answerValue) {
    var _a;
    if (!['bool', 'multiple'].includes(question.type)) {
        return false;
    }
    const { questionOptions } = question.options;
    return !!((_a = questionOptions.find(({ id }) => id === answerValue)) === null || _a === void 0 ? void 0 : _a.restrict);
}
export function isUUID(str) {
    const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidPattern.test(str);
}
export function isDateNowGreater(dateString, day) {
    const date = new Date(dateString);
    const twoDaysAgo = new Date();
    twoDaysAgo.setDate(twoDaysAgo.getDate() - day);
    return date < twoDaysAgo;
}
export function isInstaceOffline(instanceId) {
    const offline = localStorage.getItem('instanceOffline');
    if (offline && offline == instanceId) {
        return true;
    }
    return false;
}
